// DiscoverFlixMore.jsx
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';
import { useInView } from 'react-intersection-observer';

import { getIsIphoneXSeriesPWA } from '../resource/getUserAgent.js';
import { TranslationNamespace } from '../resource/translationNamespace.js';
import FlixListItem from '../container/FlixListItem.js';
import FlixCard from '../container/FlixCard.js';
import { FlixListItemPlaceholder } from '../component/FlixListItem.jsx';
import { FlixCardPlaceholder } from '../component/FlixCard.jsx';
import {
  InfiniteScroller,
  ScrollItem,
} from '../component/InfiniteScroller.jsx';
import HydrationBoundary from '../component/HydrationBoundary.jsx';
import withRouter from '../component/WithRouter.jsx';

import { headerHeight } from '../style/variables.js';
import ResetButtonStyle from '../style/ResetButtonStyle.js';
import { color } from '../style/variables.js';
import BackIcon from '../../img/ic_topbar_back.svg';
import media from '../style/media.js';

const isServer = typeof window === 'undefined';

export class DiscoverFlixMore extends Component {
  state = {
    messageIds: [],
  };
  constructor(props) {
    super(props);
    // fetch data for SSR
    const {
      staticContext,
      isFirstPageFetched,
      fetchFeeds,
      fetchMessageDetail,
      category,
      messageIds,
      isFirstMessageDetailFetched,
      senderIds,
      isFirstSenderDataFetched,
      fetchUser,
    } = this.props;
    if (staticContext.actions) {
      if (!isFirstPageFetched) {
        staticContext.actions.push({
          function: fetchFeeds,
          argumentObject: {
            type: category,
            page: 1,
            httpProxyHeaders: staticContext.httpProxyHeaders,
          },
        });
      } else {
        if (!isFirstMessageDetailFetched) {
          messageIds.forEach(messageId => {
            staticContext.actions.push({
              function: fetchMessageDetail,
              argumentObject: {
                id: messageId,
                httpProxyHeaders: staticContext.httpProxyHeaders,
              },
            });
          });
        }
        if (!isFirstSenderDataFetched) {
          senderIds.forEach(senderId => {
            staticContext.actions.push({
              function: fetchUser,
              argumentObject: {
                userId: senderId,
                httpProxyHeaders: staticContext.httpProxyHeaders,
              },
            });
          });
        }
      }
    }
    if (messageIds.length) {
      this.state.messageIds = messageIds;
    }
  }

  renderHydrateFlix = (messageId, index) => {
    const { category } = this.props;

    return (
      <FlixItemContainer key={messageId}>
        <ObservableHydrateFlixMobileItem
          messageId={messageId}
          index={index}
          category={category}
        />
        <ObservableHydrateFlixDesktopItem
          messageId={messageId}
          index={index}
          category={category}
        />
      </FlixItemContainer>
    );
  };

  renderFlix = (messageId, index) => {
    const { category } = this.props;

    return (
      <FlixItemContainer key={messageId}>
        <ObservableFlixMobileItem
          messageId={messageId}
          index={index}
          category={category}
        />
        <ObservableFlixDesktopItem
          messageId={messageId}
          index={index}
          category={category}
        />
      </FlixItemContainer>
    );
  };

  componentDidMount() {
    const { fetchFeeds, category, isFirstPageFetched } = this.props;
    if (window.__IS_HYDRATED__ || !isFirstPageFetched) {
      this.timeout = setTimeout(() => {
        const { messageIds } = this.props;
        fetchFeeds({ type: category });
        this.setState({ messageIds });
      });
    }
  }
  componentDidUpdate(prevProps) {
    const { isAuthed, category, messageIds, fetchFeeds } = this.props;
    if (isAuthed !== prevProps.isAuthed) {
      fetchFeeds({ type: category });
    }
    if (
      messageIds !== prevProps.messageIds ||
      messageIds.length !== this.state.messageIds.length
    ) {
      this.timeout && clearTimeout(this.timeout);
      this.setState({ messageIds });
    }
  }
  componentWillUnmount() {
    this.timeout && clearTimeout(this.timeout);
    if (!window.__IS_HYDRATED__) {
      window.__IS_HYDRATED__ = 'DiscoverFlixMore';
    }
  }
  render() {
    const { messageIds } = this.state;
    const { nextPage, titleI18nId, goBack, t, fetchFeeds, category } =
      this.props;
    const shouldHydrate = isServer || !window.__IS_HYDRATED__;
    const renderFlix = shouldHydrate ? this.renderHydrateFlix : this.renderFlix;

    return (
      <StyledDiscoverFlixMore>
        <Header>
          <HeaderLeft>
            <GoBack onClick={goBack}>
              <img src={BackIcon} title="close" />
            </GoBack>
          </HeaderLeft>
          <HeaderMain>
            <Title>
              {t(titleI18nId, {
                ns: TranslationNamespace.FEED,
              })}
            </Title>
          </HeaderMain>
        </Header>
        <DiscoverFlixMoreContainer>
          <Body isIphoneXSeriesPWA={getIsIphoneXSeriesPWA()}>
            <InfiniteScroller
              pageStart={1}
              threshold={100}
              hasMore={nextPage != null}
              loadMore={() =>
                fetchFeeds({
                  type: category,
                  page: nextPage,
                })
              }
              isFetching={this.props.isFetching}
            >
              <ScrollItem
                loader={
                  <FlixCardWrapper>
                    <FlixCardPlaceholder />
                  </FlixCardWrapper>
                }
              >
                {messageIds.map(renderFlix)}
              </ScrollItem>
            </InfiniteScroller>
          </Body>
        </DiscoverFlixMoreContainer>
      </StyledDiscoverFlixMore>
    );
  }
}

DiscoverFlixMore.propTypes = {
  staticContext: PropTypes.object,
  isAuthed: PropTypes.bool,
  isFirstPageFetched: PropTypes.bool,
  isFetching: PropTypes.bool,
  isFirstMessageDetailFetched: PropTypes.bool,
  category: PropTypes.string,
  titleI18nId: PropTypes.string,
  messageIds: PropTypes.array,
  senderIds: PropTypes.array,
  isFirstSenderDataFetched: PropTypes.bool,
  fetchFeeds: PropTypes.func,
  fetchMessageDetail: PropTypes.func,
  fetchUser: PropTypes.func,
  goBack: PropTypes.func,
  t: PropTypes.func.isRequired,
  nextPage: PropTypes.number,
};
DiscoverFlixMore.defaultProps = {
  staticContext: {},
  isAuthed: false,
  isFirstPageFetched: false,
  isFetching: false,
  isFirstMessageDetailFetched: false,
  messageIds: [],
  category: '',
  titleI18nId: '',
  senderIds: [],
  isFirstSenderDataFetched: false,
  fetchFeeds: () => null,
  fetchMessageDetail: () => null,
  fetchUser: () => null,
  goBack: () => null,
  nextPage: null,
  currentPage: 1,
  limit: 20,
};

const StyledDiscoverFlixMore = styled.div`
  position: relative;
  padding-top: var(--space-to-pinned-notification);
`;
const Header = styled.header`
  position: fixed;
  z-index: 3;
  border-bottom: 1px solid rgba(100, 100, 100, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: ${headerHeight}px;
  top: var(--space-to-pinned-notification);
  background-color: ${color.grey['900']};
  font-size: 16px;
  font-weight: 600;
`;

const Title = styled.h1`
  margin: 0;
  margin-left: 4px;
  font-size: 18px;
  font-weight: 600;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: calc(100% - 30px);
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  width: 36px;
`;

const HeaderMain = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  padding-right: 36px;
  max-width: calc(100% - 72px);
`;

const GoBack = styled.button`
  ${ResetButtonStyle};
  flex: none;
  height: 32px;
  :hover {
    opacity: 0.7;
  }
  & > img {
    height: 100%;
    vertical-align: top;
  }
`;

const FlixItemContainer = styled.div`
  display: contents;
  width: 100%;
`;

const MobileWrapper = styled.div`
  display: none;

  ${media.mobile`
    display: block;
  `}
`;

const DesktopWrapper = styled.div`
  display: block;

  ${media.mobile`
    display: none;
  `}
`;

const DiscoverFlixMoreContainer = styled.main`
  padding-top: ${headerHeight + 1}px;
  padding-bottom: 40px;
  ${media.mobile`
    padding-bottom: unset;
  `}
`;

const Body = styled.div`
  padding: 16px 16px 32px 16px;
  ${({ isIphoneXSeriesPWA }) =>
    isIphoneXSeriesPWA ? 'padding-bottom: 82px;' : ''}

  max-width: 962px;
  min-height: 75vh;
  margin: 0 auto;

  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(224px, 1fr));
  grid-gap: 8px;
  ${media.mobile`
    display: block;
  `}
`;

const FlixCardWrapper = styled.div`
  height: 100%;
`;

const FlixListItemWrapper = styled.div`
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(100, 100, 100, 0.5);
  margin-bottom: 8px;
  &:last-of-type {
    border-bottom: unset;
  }
`;

const OBSERVER_OPTIONS = {
  threshold: 0.2,
  triggerOnce: true,
};

const ObservableHydrateFlixMobileItem = ({ messageId, index, category }) => {
  const { ref, inView } = useInView(OBSERVER_OPTIONS);
  return (
    <MobileWrapper ref={ref}>
      {inView ? (
        <HydrationBoundary
          shouldHydrate={inView}
          wrapper={<FlixListItemWrapper />}
        >
          <FlixListItem
            shouldUseLink
            messageId={messageId}
            id={messageId}
            categoryId={category}
            itemIndexInCategory={index}
          />
        </HydrationBoundary>
      ) : (
        <FlixListItemWrapper>
          <FlixListItemPlaceholder />
        </FlixListItemWrapper>
      )}
    </MobileWrapper>
  );
};

ObservableHydrateFlixMobileItem.propTypes = {
  messageId: PropTypes.string,
  index: PropTypes.number,
  category: PropTypes.string,
};

const ObservableHydrateFlixDesktopItem = ({ messageId, index, category }) => {
  const { ref, inView } = useInView(OBSERVER_OPTIONS);
  return (
    <DesktopWrapper ref={ref}>
      {inView ? (
        <HydrationBoundary shouldHydrate={inView} wrapper={<FlixCardWrapper />}>
          <FlixCard
            categoryId={category}
            itemIndexInCategory={index}
            messageId={messageId}
            shouldShowAvatar
            shouldShowUsername
            shouldAnimateLoader={inView}
            isIntersecting={inView}
            shouldShowLiveStream={false}
            shouldShowOnline={false}
          />
        </HydrationBoundary>
      ) : (
        <FlixCardWrapper>
          <FlixCardPlaceholder />
        </FlixCardWrapper>
      )}
    </DesktopWrapper>
  );
};

ObservableHydrateFlixDesktopItem.propTypes = {
  messageId: PropTypes.string,
  index: PropTypes.number,
  category: PropTypes.string,
};

const ObservableFlixMobileItem = ({ messageId, index, category }) => {
  const { ref, inView } = useInView(OBSERVER_OPTIONS);
  return (
    <MobileWrapper ref={ref}>
      {inView ? (
        <FlixListItemWrapper>
          <FlixListItem
            shouldUseLink
            messageId={inView ? messageId : null}
            id={messageId}
            categoryId={category}
            itemIndexInCategory={index}
          />
        </FlixListItemWrapper>
      ) : (
        <FlixListItemWrapper>
          <FlixListItemPlaceholder />
        </FlixListItemWrapper>
      )}
    </MobileWrapper>
  );
};

ObservableFlixMobileItem.propTypes = {
  messageId: PropTypes.string,
  index: PropTypes.number,
  category: PropTypes.string,
};

const ObservableFlixDesktopItem = ({ messageId, index, category }) => {
  const { ref, inView } = useInView(OBSERVER_OPTIONS);
  return (
    <DesktopWrapper ref={ref}>
      {inView ? (
        <FlixCardWrapper>
          <FlixCard
            categoryId={category}
            itemIndexInCategory={index}
            messageId={messageId}
            shouldShowAvatar
            shouldShowUsername
            shouldAnimateLoader={inView}
            isIntersecting={inView}
            shouldShowLiveStream={false}
            shouldShowOnline={false}
          />
        </FlixCardWrapper>
      ) : (
        <FlixCardWrapper>
          <FlixCardPlaceholder />
        </FlixCardWrapper>
      )}
    </DesktopWrapper>
  );
};

ObservableFlixDesktopItem.propTypes = {
  messageId: PropTypes.string,
  index: PropTypes.number,
  category: PropTypes.string,
};

export default withTranslation()(withRouter(DiscoverFlixMore));
